import { useSelector } from "react-redux";
import {
  GetKeepFiltersFlag,
  GetTimeProjectsWithAllLogic,
  IsShowAdditionalFilters,
  selectClientsQuery,
  SelectCostCentersQuery,
  selectCountriesQuery,
  SelectFilters,
  SelectInitialStateFilters,
  selectIsInfoQueryLoaded,
  selectProjectManagersQuery,
  selectProjectsQuery,
  SelectUsersQuery,
} from "../redux/reducers/timesQuery.reducer";
import { hasTimeAdminAccess, hasTimeViewerAccess } from "../utils/timesUtils";
import { selectMetaTimesData } from "../redux/reducers/metaTimes.reducer";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { isDeliveryTimeAdminChecker } from "../../SharedModule/utils/accessUtils";
import { useTimesMetadata } from "./useTimesMetadata";

export const useQueryPage = () => {
  useTimesMetadata();
  const isInfoQueryLoaded = useSelector(selectIsInfoQueryLoaded);
  const costCentersQuery = useSelector(SelectCostCentersQuery);
  const clientsQuery = useSelector(selectClientsQuery);
  const projectsQuery = useSelector(selectProjectsQuery);
  const projectManagersQuery = useSelector(selectProjectManagersQuery);
  const usersQuery = useSelector(SelectUsersQuery);
  const countriesQuery = useSelector(selectCountriesQuery);

  const MetaTimesInfo = useSelector(selectMetaTimesData);
  const filters = useSelector(SelectFilters);
  const isShowAdditionalFilters = useSelector(IsShowAdditionalFilters);
  const initialStatefilters = useSelector(SelectInitialStateFilters);

  const { userRolesList } = useSelector(selectUserRoles);

  const keepFiltersFlag = useSelector(GetKeepFiltersFlag);
  const timeProjectsWithAllLogicData = useSelector(GetTimeProjectsWithAllLogic);

  const isTimeAdmin = hasTimeAdminAccess(userRolesList);
  const isTimeViewer = hasTimeViewerAccess(userRolesList);
  const isDeliveryTimeAdmin = isDeliveryTimeAdminChecker(userRolesList);

  return {
    isInfoQueryLoaded,
    costCentersQuery,
    clientsQuery,
    projectsQuery,
    projectManagersQuery,
    usersQuery,
    countriesQuery,
    MetaTimesInfo,
    filters,
    isShowAdditionalFilters,
    initialStatefilters,
    isTimeAdmin,
    isTimeViewer,
    isDeliveryTimeAdmin,
    keepFiltersFlag,
    timeProjectsWithAllLogicData,
  };
};
